// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"153":"64709f91","297":"81731d95","950":"9984abc8"}[chunkId] + ".js";
};